var _rect, _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecordOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    rx: 22.5,
    fill: "black",
    fillOpacity: 0.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 22.5,
    r: 14,
    stroke: "#FF0000"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2673 21.224C19.2673 22.1467 18.8647 22.728 18.0593 22.968L19.5233 25H18.3233L16.9873 23.12H15.7473V25H14.8033V19.408H16.8833C17.7367 19.408 18.3473 19.552 18.7153 19.84C19.0833 20.128 19.2673 20.5893 19.2673 21.224ZM16.9233 22.264C17.4567 22.264 17.8193 22.1813 18.0113 22.016C18.2033 21.8507 18.2993 21.5867 18.2993 21.224C18.2993 20.856 18.2007 20.6053 18.0033 20.472C17.806 20.3333 17.454 20.264 16.9473 20.264H15.7473V22.264H16.9233ZM24.5517 19.408V20.296H21.5677V21.776H24.2477V22.616H21.5677V24.112H24.6477V25H20.6237V19.408H24.5517ZM28.41 24.144C28.7354 24.144 29.0154 24.0907 29.25 23.984C29.4847 23.872 29.73 23.696 29.986 23.456L30.594 24.08C30.002 24.736 29.282 25.064 28.434 25.064C27.5914 25.064 26.89 24.792 26.33 24.248C25.7754 23.704 25.498 23.016 25.498 22.184C25.498 21.352 25.7807 20.6587 26.346 20.104C26.9167 19.5493 27.634 19.272 28.498 19.272C29.3674 19.272 30.0927 19.592 30.674 20.232L30.074 20.888C29.8074 20.632 29.554 20.4533 29.314 20.352C29.0794 20.2507 28.802 20.2 28.482 20.2C27.9167 20.2 27.442 20.384 27.058 20.752C26.674 21.1147 26.482 21.5813 26.482 22.152C26.482 22.7173 26.6714 23.192 27.05 23.576C27.434 23.9547 27.8874 24.144 28.41 24.144Z",
    fill: "#FF0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecordOff);
export default __webpack_public_path__ + "static/media/record-off.d55d6d73b94fda2e39ff29d177c38d4d.svg";
export { ForwardRef as ReactComponent };